"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmplifyInit = void 0;
const auth_1 = require("@aws-amplify/auth");
const react_1 = require("react");
const _1 = require(".");
const amplifyConfig_1 = require("../utils/amplifyConfig");
let isAmplifyConfigured = false;
let lastConfigOptions = null;
/**
 * Hook to initialize AWS Amplify with the provided configuration
 * @param options Configuration options for Amplify
 * @returns Object containing initialization status, any error, and auth functions
 */
const useAmplifyInit = (options) => {
    const logger = (0, _1.useLogger)('useAmplifyInit');
    const [isInitialized, setIsInitialized] = (0, react_1.useState)(isAmplifyConfigured);
    const [error, setError] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const configChanged = !lastConfigOptions || JSON.stringify(lastConfigOptions) !== JSON.stringify(options);
        if (isAmplifyConfigured && !configChanged) {
            setIsInitialized(true);
            logger.warn('Amplify already initialized');
            return;
        }
        try {
            if (isAmplifyConfigured && configChanged) {
                logger.debug('[Amplify] Configuration changed, reconfiguring Amplify');
                isAmplifyConfigured = false;
            }
            // Hack to reset Amplify
            (0, amplifyConfig_1.configureAmplify)({});
            (0, amplifyConfig_1.configureAmplify)({
                ...options,
                isWeb: options.isWeb === true,
            });
            lastConfigOptions = { ...options };
            isAmplifyConfigured = true;
            setIsInitialized(true);
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
            logger.error('Error initializing Amplify', { error: err });
        }
    }, [options]);
    const signIn = (0, react_1.useCallback)(async (params) => {
        if (!isInitialized) {
            throw new Error('Amplify is not initialized yet');
        }
        return (0, auth_1.signInWithRedirect)(params);
    }, [isInitialized]);
    return {
        isInitialized,
        error,
        signInWithRedirect: signIn,
    };
};
exports.useAmplifyInit = useAmplifyInit;
